import React, {useRef, useState} from 'react'
import {ToastContainer} from 'react-toastify'
import {useFormik} from 'formik'
import LoadingComponent from '../../components/LoadingComponent/LoadingComponent'
import notifyToast from '../../components/Toast/Toast'
import {
    isporuciThermoBoradPakete,
    proizvediThermoBoradPakete, raspolozivThermoBoradPaket,
    rezervisiThermoBoradPakete,
} from '../../api/thermoBoardPaketi'

type Data = {
    stavkaId: number[]
    kupac?: string
}

const UpdateStatusComponent = ({table, update}) => {
    const [loading, setLoading] = useState(false)
    const activeButtonRef = useRef('')
    const selectedRowsCount = table.getSelectedRowModel().rows.length

    const formik = useFormik({
        initialValues: {
            Kupac: '',
        },
        onSubmit: async (values, {setStatus, setSubmitting}) => {
            setLoading(true)

            const activeButton = activeButtonRef.current
            const selectedRows = table.getSelectedRowModel().rows.map((row) => row.original.Id)

            try {
                let response
                const data: Data = {
                    stavkaId: selectedRows,
                }

                if (activeButton !== 'proizvedi') {
                    data.kupac = values.Kupac
                }

                if (activeButton === 'rezervisi') {
                    response = await rezervisiThermoBoradPakete(data)
                } else if (activeButton === 'proizvedi') {
                    response = await proizvediThermoBoradPakete(data)
                } else if (activeButton === 'respoloziv') {
                    response = await raspolozivThermoBoradPaket(data)
                }

                if (response.error === 0) {
                    notifyToast(true, response.message)
                    update()
                } else {
                    notifyToast(false, response.message || 'An unexpected error occurred.')
                }
            } catch (error) {
                setStatus(error)
            } finally {
                setLoading(false)
                setSubmitting(false)
            }
        },
    })

    const handleButtonClick = (buttonType) => {
        activeButtonRef.current = buttonType
        formik.submitForm()
    }

    return (
        <div className='card shadow-sm mb-5 mb-xl-10'>
            <ToastContainer/>
            {loading ? (
                <LoadingComponent/>
            ) : (
                <form onSubmit={formik.handleSubmit} noValidate className='form'>
                    <div className='card-body py-5'>
                        <div
                            className='d-flex flex-column flex-xl-row gap-5 align-items-xl-end justify-content-between'>
                            <div className='w-100 mw-425px'>
                                <div className='text-muted fs-7 mt-2'>
                                    Odabrano paketa: <span className='fw-bold'>{selectedRowsCount}</span>
                                </div>
                            </div>

                            <div className='d-flex flex-wrap gap-3 justify-content-xl-end'>

                                <button
                                    type='button'
                                    className='btn btn-light-warning fw-bold px-6'
                                    onClick={() => handleButtonClick('proizvedi')}
                                    disabled={!selectedRowsCount}
                                >
                                    Proizvedi pakete
                                </button>

                                <button
                                    type='button'
                                    className='btn btn-light-primary fw-bold px-6'
                                    onClick={() => handleButtonClick('respoloziv')}
                                    disabled={!selectedRowsCount}
                                >
                                    Raspoloživ paket
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
            )}
        </div>
    )
}

export default UpdateStatusComponent
